import { CollapsedIcon } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/CollapsedIcon";
import { TrainIndicator } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/TrainIndicator";
import { getLabelForAltTransStation } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/utils";
import { AltTransIncidentTrain } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import { Text, tokens } from "shared/components/Spor";
import styled from "styled-components";

const ContentWrapper = styled.div`
  border-radius: ${tokens.default.size.spacing[1]};
  padding: ${tokens.default.size.spacing[2.5]};
  background-color: ${({ theme }) => theme.colorBackgroundTertiary};

  display: flex;
  flex-flow: row nowrap;
  gap: ${tokens.default.size.spacing[1]};
  justify-content: space-between;
  align-items: center;
`;

type CollapsedTrainItemProps = {
  actionableTrain: AltTransIncidentTrain;
};

export const CollapsedTrainItem: FC<CollapsedTrainItemProps> = ({
  actionableTrain,
}) => {
  const {
    trainRoute: { originStop, destinationStop },
    incidentArrival,
    id: { id },
  } = actionableTrain;

  return (
    <ContentWrapper>
      <TrainIndicator trainNumber={id} incidentArrival={incidentArrival} />
      <Text flexGrow={1} variant="sm">
        {getLabelForAltTransStation(originStop)}–
        {getLabelForAltTransStation(destinationStop)}
      </Text>
      <CollapsedIcon actionableTrain={actionableTrain} />
    </ContentWrapper>
  );
};
